import { Attr, Model } from 'spraypaint';
import ApplicationRecord from '@spraypaint/ApplicationRecord';
import { Option } from '@common/components/inputs/Select';
import { useTranslation } from 'react-i18next';
import dayjs, { Dayjs } from 'dayjs';

const STATUSES = ['pending', 'error', 'synced', 'ignored'] as const;
type SyncStatuses = (typeof STATUSES)[number];

export function useSyncStatusesOptions(): Option[] {
  const { t } = useTranslation();

  return STATUSES.map((status) => ({
    label: t(`activerecord.enums.dendreo/invoice_sync_state.status.${status}`, {
      ns: 'rails',
    }),
    value: status,
  }));
}

@Model()
class DendreoSyncInvoiceRequest extends ApplicationRecord {
  static jsonapiType = 'dendreo-invoice_sync_states';

  // Attributes
  @Attr() number!: string;
  @Attr() status!: SyncStatuses;
  @Attr() invoiceDate!: string;
  @Attr() createdAt!: string;
  @Attr() updatedAt!: string;
  @Attr() syncedAt!: string;
  @Attr() invoicableId!: string;
  @Attr() invoicableType!: string;
  @Attr() invoicableUrl!: string;
  @Attr() markedIgnored!: boolean;

  // Extra-attributes

  // Relationships
}

export default DendreoSyncInvoiceRequest;
